import React, { Component } from "react";
import {
  company,
  loading,
  NavbarAdmin,
  Pagination,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  Modal,
  Select,
  format_date,
  t // นำเข้าฟังก์ชันแปลภาษา
} from "../../components/CustomComponent.js"; 

export default class ChecklistTemplates extends Component {
  constructor(props) {
    super(props);
   this.state = {
      page: 1,
      page_size: 100000,
      uid: "",
      modal_create: false,
      modal_update: false,
      modal_view: false,
      filter_search: "",
      asset_group_id: "",

      template_name: "",
      category: "",
      description: "",
      checklist_items: [],
      drag_item_id: null,
      drag_over_item_id: null,
      view_data: null,
      data_categories: [],
      tabs: [{ value: "", label: t("all_templates") }],

      data: []
    };
  }

  async componentDidMount() {
    this.Get(1);
  }

  normalizeArrayData = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    if (payload && typeof payload === "object") return [payload];
    return [];
  }

  Get = async (page) => {
    const { filter_search, page_size, asset_group_id } = this.state;
    loading(true);
    let [resultTemplates, resultCategories] = await Promise.all([
      GET("admin/checklist-templates", {
        page: page,
        page_size: page_size,
        data_search: filter_search || "",
        asset_group_id: asset_group_id || "",
        uid: ""
      }),
      GET("warehouse/part-categories", { page_size: 10000, page: 0 })
    ]);

    const templateData = resultTemplates?.status ? this.normalizeArrayData(resultTemplates.data) : [];
    const categoryOptions = resultCategories?.status
      ? this.normalizeArrayData(resultCategories.data).map((item) => ({ value: item.uid, label: item.name }))
      : [];
    const fallbackCategories = templateData
      .map((item) => ({
        value: item.asset_group?.uid || "",
        label: item.asset_group?.name || t("general")
      }))
      .filter((item) => item.value && item.label);
    const dataCategories = categoryOptions.length > 0
      ? categoryOptions
      : fallbackCategories.filter((item, index, self) => self.findIndex((entry) => entry.value === item.value) === index);
    const tabs = [
      ...dataCategories
    ];

    if (resultTemplates?.status || resultCategories?.status) {
      this.setState({
        data: templateData,
        data_categories: dataCategories,
        tabs,
        page: page
      });
    }
    loading(false);
  };

  handleSave = async () => {
    const { uid, template_name, category, description, checklist_items } = this.state;
    if (!template_name) {
      alert("", "warning", t("warning"), t("please_enter_template_name"));
      return;
    }
    if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
      loading(true);
      const payload = {
        company_id: company?.id || "",
        asset_group_id: category,
        name: template_name,
        description: description,
        items: checklist_items.map((item, index) => ({
          sequence: item.sequence || index + 1,
          description: item.description || "",
          input_type: item.input_type || "check",
          unit: item.unit || "",
          min: Number(item.min) || 0,
          max: Number(item.max) || 0
        }))
      };

      let result = !uid
        ? await POST("admin/checklist-templates", payload)
        : await PUT("admin/checklist-templates/" + uid, payload);

      if (result?.status === true) {
        alert("#", "success", t("success"), t("save_success"));
        this.setState({ modal_create: false, modal_update: false });
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || t("error_occurred"));
      }
      loading(false);
    }
  };

  handleDelete = async (id) => {
    if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
      loading(true);
      let result = await DELETE("admin/checklist-templates/" + id, null);
      if (result?.status) {
        alert("#", "success", t("success"), t("delete_success"));
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || t("error_occurred"));
      }
      loading(false);
    }
  };

  addChecklistItem = () => {
    const newItems = [
      ...this.state.checklist_items,
      {
        id: Date.now(),
        sequence: this.state.checklist_items.length + 1,
        description: "",
        input_type: "check",
        unit: "",
        min: "",
        max: ""
      }
    ];
    this.setState({ checklist_items: newItems });
  }

  removeChecklistItem = async (index) => {
    if (!(await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel")))) {
      return;
    }
    const newItems = [...this.state.checklist_items];
    newItems.splice(index, 1);
    this.setState({
      checklist_items: newItems.map((item, itemIndex) => ({
        ...item,
        sequence: itemIndex + 1
      }))
    });
  }

  updateChecklistItem = (index, field, value) => {
    const newItems = [...this.state.checklist_items];
    newItems[index][field] = value;
    this.setState({ checklist_items: newItems });
  }

  openCreateModal = () => {
    this.setState({
      modal_create: true, modal_update: false, modal_view: false,
      uid: "", template_name: "", category: "", description: "",
      checklist_items: [
        { id: Date.now(), sequence: 1, description: "", input_type: "check", unit: "", min: "", max: "" }
      ],
      drag_item_id: null,
      drag_over_item_id: null,
    });
  }

  openEditModal = (item) => {
    this.setState({
      modal_create: false, modal_update: true, modal_view: false,
      uid: item.uid,
      template_name: item.name, category: item.asset_group?.uid || "", description: item.description,
      checklist_items: (item.items || []).map(i => ({
        id: i.uid || Date.now() + Math.random(),
        sequence: i.sequence || 0,
        description: i.description || "",
        input_type: i.input_type || "check",
        unit: i.unit || "",
        min: i.min || "",
        max: i.max || ""
      })).sort((a, b) => (a.sequence || 0) - (b.sequence || 0)).map((checklistItem, index) => ({
        ...checklistItem,
        sequence: index + 1
      })),
      drag_item_id: null,
      drag_over_item_id: null,
    });
  }

  handleChecklistDragStart = (itemId) => {
    this.setState({ drag_item_id: itemId, drag_over_item_id: itemId });
  };

  handleChecklistDragOver = (e, itemId) => {
    e.preventDefault();
    if (this.state.drag_over_item_id !== itemId) {
      this.setState({ drag_over_item_id: itemId });
    }
  };

  handleChecklistDragEnd = () => {
    this.setState({ drag_item_id: null, drag_over_item_id: null });
  };

  reorderChecklistItems = (items, fromId, toId) => {
    const fromIndex = items.findIndex((item) => item.id === fromId);
    const toIndex = items.findIndex((item) => item.id === toId);
    if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) return null;

    const nextItems = [...items];
    const [movedItem] = nextItems.splice(fromIndex, 1);
    nextItems.splice(toIndex, 0, movedItem);

    return nextItems.map((item, index) => ({
      ...item,
      sequence: index + 1
    }));
  };

  handleChecklistDrop = (dropItemId) => {
    const { checklist_items, drag_item_id } = this.state;
    if (!drag_item_id || drag_item_id === dropItemId) {
      this.handleChecklistDragEnd();
      return;
    }

    const reorderedItems = this.reorderChecklistItems(checklist_items, drag_item_id, dropItemId);
    if (!reorderedItems) {
      this.handleChecklistDragEnd();
      return;
    }

    this.setState({
      checklist_items: reorderedItems,
      drag_item_id: null,
      drag_over_item_id: null
    });
  };

  openViewModal = (item) => {
    this.setState({
      modal_view: true,
      modal_create: false,
      modal_update: false,
      view_data: item
    });
  }

  getCategoryLabel = (item) => {
    const categoryId = item?.asset_group?.uid || "";
    return this.state.data_categories.find((category) => category.value === categoryId)?.label
      || item?.asset_group?.name
      || t("general");
  }

  render() {
   const {
      modal_create, modal_update, modal_view, filter_search, asset_group_id, tabs, data,
      template_name, category, description, checklist_items, view_data, data_categories, drag_over_item_id
    } = this.state;
    const filteredData = data;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarAdmin />
            <div className="body p-4 mt-3">
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("checklist_templates")}</h3>
                        <div className="text-secondary text-14">{t("checklist_desc")}</div>
                    </div>
                </div>

                <div className="row g-3 mb-4">
                    <div className="col-lg-3 col-md-6">
                        <div className="card border border-primary rounded-4 shadow-sm p-3 h-100" style={{ borderLeft: "4px solid #0d6efd !important" }}>
                            <div className="d-flex justify-content-between align-items-start">
                                <div>
                                    <div className="text-secondary text-14 mb-1">{t("total_templates")}</div>
                                    <h2 className="fw-bold mb-0 text-dark">{filteredData.length || 0}</h2>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center text-20 icon">{"\uf46c"}</div>
                            </div>
                        </div>
                    </div>
                    {/* KPI อื่นๆ ใช้โครงสร้างเดียวกัน */}
                    <div className="col-lg-3 col-md-6">
                        <div className="card border border-success rounded-4 shadow-sm p-3 h-100" style={{ borderLeft: "4px solid #198754 !important" }}>
                            <div className="d-flex justify-content-between align-items-start">
                                <div>
                                    <div className="text-secondary text-14 mb-1">{t("active")}</div>
                                    <h2 className="fw-bold mb-0 text-success">{filteredData.filter((e) => e.is_active)?.length || 0}</h2>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">{"\uf058"}</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <div className="card border border-secondary rounded-4 shadow-sm p-3 h-100" style={{ borderLeft: "4px solid #ffc107 !important" }}>
                            <div className="d-flex justify-content-between align-items-start">
                                <div>
                                    <div className="text-secondary text-14 mb-1">{t("inactive")}</div>
                                    <h2 className="fw-bold mb-0 text-warning">{filteredData.filter((e) => !e.is_active)?.length || 0}</h2>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-warning-light text-warning d-flex align-items-center justify-content-center text-20 icon">{"\uf06a"}</div>
                            </div>
                        </div>
                    </div>
                    {/* ... Draft และ Total Items ... */}
                </div>

                {/* Main White Container */}
                <div className="rounded-4 bg-white p-3 mb-3 shadow-sm border-0">
                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                        <div className="d-flex flex-wrap gap-2 flex-grow-1">
                            <div className="position-relative">
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                                <input
                                    type="text"
                                    className="form-control ps-5 wpx-350"
                                    style={{ height: "38px" }}
                                    placeholder={t("search")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                />
                            </div>
                            <Select
                                className="form-control wpx-280"
                                options={tabs}
                                value={asset_group_id}
                                onChange={(e) => this.setState({ asset_group_id: e || "" })}
                                placeholder={t("all_templates")}
                            />
                            <div className="d-flex gap-2">
                                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                    {t("filter")}
                                </button>
                                <button
                                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                    onClick={() => this.setState({ filter_search: "", asset_group_id: "" }, () => this.Get(1))}
                                >
                                    {t("clear_all")}
                                </button>
                            </div>
                        </div>
                        <button className="btn btn-primary fw-bold px-3 py-2 rounded-3 shadow-sm d-flex align-items-center" onClick={this.openCreateModal}>
                            <span className="me-2">+</span> {t("new_template")}
                        </button>
                    </div>
                </div>

                <div className="row g-3">
                    {filteredData.map((item, idx) => (
                        <div key={idx} className="col-lg-4 col-md-4">
                            <div className="card border-0 rounded-4 shadow-sm p-4 h-100 bg-white">
                                <div className="pointer" onClick={() => this.openViewModal(item)}>
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                        <span
                                            className={`badge rounded-2 px-2 py-1 text-10 fw-bold bg-${item.asset_group?.uid ? "primary" : "secondary"}-light text-${
                                                item.asset_group?.uid ? "primary" : "secondary"
                                            }`}
                                        >
                                            {this.getCategoryLabel(item)}
                                        </span>
                                        <span className={`text-12 fw-bold ${item.is_active !== false ? "text-success" : "text-warning"}`}>
                                            {item.is_active !== false ? t("active") : t("inactive")}
                                        </span>
                                    </div>

                                    <h5 className="fw-bold text-dark mb-2 text-truncate">{item.name}</h5>
                                    <div
                                        className="text-secondary text-12 mb-2"
                                        style={{ height: "36px", overflow: "hidden", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}
                                    >
                                        {item.description}
                                    </div>

                                    <div className="d-flex justify-content-between text-secondary text-12 mb-3">
                                        <div className="d-flex align-items-center fw-bold text-primary">
                                            <span className="icon me-2">{"\uf0ca"}</span> {item.items?.length || 0} {t("items")}
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <span className="icon me-2">{"\uf012"}</span> {t("used")} {item.usage_count || 0} {t("times")}
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="text-secondary text-10">
                                        {t("last_used")}: {item.updated_at ? format_date(item.updated_at.split("T")[0], "dd-mm-yyyy", "th") : "-"}
                                    </div>
                                    <div className="d-flex gap-2 text-16">
                                        <span
                                            className="icon text-secondary pointer hover-primary transition-hover"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                this.openEditModal(item);
                                            }}
                                        >
                                            {"\uf044"}
                                        </span>
                                        <span
                                            className="icon text-secondary pointer hover-danger transition-hover"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                this.handleDelete(item.uid);
                                            }}
                                        >
                                            {"\uf2ed"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Pagination */}
                {/* <div className="d-flex justify-content-between align-items-center mt-4">
                  <div className="text-secondary text-12">
                    {t("showing")} 1-{filteredData.length} {t("of")} {count} {t("items")}
                  </div>
                  <Pagination
                    count={Math.ceil(count / this.state.page_size) || 1}
                    page={this.state.page}
                    onChange={(_, p) => this.Get(p)}
                    showFirstButton={false} showLastButton={false}
                  />
                </div> */}
            </div>

            {/* MODAL: VIEW */}
            <Modal size="md" show={modal_view} onHide={() => this.setState({ modal_view: false })} centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg">
                <Modal.Header className="border-bottom px-4 py-3 bg-white" closeButton>
                    <div className="w-100 pe-4">
                        <span className={`badge bg-primary-light text-primary rounded-pill px-3 py-1 mb-2 fw-bold text-12`}>{this.getCategoryLabel(view_data)}</span>
                        <h4 className="fw-bold mb-1 text-dark">{view_data?.name || t("template_title")}</h4>
                        <div className="text-secondary text-14">{view_data?.description}</div>
                    </div>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white" style={{ maxHeight: "65vh", overflowY: "auto" }}>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6 className="fw-bold text-dark d-flex align-items-center m-0">
                            <span className="icon text-primary me-2">{"\uf0ca"}</span> {t("checklist_items")}
                        </h6>
                        <span className="text-secondary fw-bold text-14">
                            {view_data?.items?.length || 0} {t("items")}
                        </span>
                    </div>
                    <div className="d-flex flex-column gap-2">
                        {view_data?.items?.map((item, idx) => (
                            <div key={idx} className="d-flex align-items-center justify-content-between bg-light rounded-3 p-3">
                                <div className="d-flex align-items-center">
                                    <div className="wpx-25 hpx-25 rounded-circle bg-primary-light text-primary d-flex align-items-center justify-content-center fw-bold text-12 me-3 flex-shrink-0">
                                        {idx + 1}
                                    </div>
                                    <div className="text-dark text-14">{item.description}</div>
                                </div>
                                <div className="ms-3 flex-shrink-0">
                                    <span className={`badge bg-primary-light text-primary fw-bold px-3 py-1 text-12`}>{item.input_type}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-end align-items-center">
                    <div className="d-flex gap-2">
                        <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold shadow-sm" onClick={() => this.setState({ modal_view: false })}>
                            {t("close")}
                        </button>
                        <button className="btn btn-primary px-4 py-2 rounded-3 d-flex align-items-center fw-bold shadow-sm" onClick={() => this.openEditModal(view_data)}>
                            <span className="icon me-2">{"\uf044"}</span> {t("edit")}
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            {/* MODAL: CREATE & EDIT */}
            <Modal
                size="xl"
                show={modal_create || modal_update}
                onHide={() => this.setState({ modal_create: false, modal_update: false })}
                centered
                contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
            >
                <Modal.Header className="border-0 px-4 py-3" style={{ backgroundColor: "#2563eb" }}>
                    <div className="text-white">
                        <h4 className="fw-bold mb-1 text-white">{t("create_new_template")}</h4>
                        <div className="text-white-50 text-14" style={{ color: "#bfdbfe" }}>
                            {t("create_template_desc")}
                        </div>
                    </div>
                    <button
                        type="button"
                        className="btn-close btn-close-white"
                        style={{ backgroundColor: "rgba(255, 255, 255, 0.2)", borderRadius: "8px", padding: "0.6rem" }}
                        onClick={() => this.setState({ modal_create: false, modal_update: false })}
                    ></button>
                </Modal.Header>

                <Modal.Body className="p-4 bg-white">
                    <div className="row g-3 mb-4 pb-4">
                        <div className="col-md-6">
                            <label className="form-label text-14 fw-bold text-dark">
                                {t("template_name_label")} <span className="text-danger">*</span>
                            </label>
                            <input
                                type="text"
                                className="form-control py-2 text-dark"
                                placeholder={t("template_name_placeholder")}
                                value={template_name}
                                onChange={(e) => this.setState({ template_name: e.target.value })}
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 fw-bold text-dark">
                                {t("machine_asset_group")} <span className="text-danger">*</span>
                            </label>
                            <Select
                                className="form-control w-100"
                                options={data_categories}
                                value={category}
                                onChange={(e) => this.setState({ category: e })}
                                placeholder={t("select_machine_asset_group_placeholder")}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label className="form-label text-14 fw-bold text-dark">{t("description")}</label>
                            <textarea
                                className="form-control"
                                rows="3"
                                placeholder={t("checklist_description_placeholder")}
                                value={description}
                                onChange={(e) => this.setState({ description: e.target.value })}
                            ></textarea>
                        </div>
                    </div>

                    <div>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="fw-bold text-dark mb-0">{t("checklist_items")}</h5>
                            <button
                                className="btn btn-sm fw-bold px-3 py-2 d-flex align-items-center rounded-3"
                                style={{ backgroundColor: "#eff6ff", color: "#2563eb", border: "1px solid #bfdbfe" }}
                                onClick={this.addChecklistItem}
                            >
                                <span className="me-2">+</span> {t("add_item")}
                            </button>
                        </div>

                        <div className="d-flex flex-column gap-3 mb-4">
                            {checklist_items.map((item, idx) => (
                                <div
                                    key={item.id}
                                    className="d-flex align-items-center gap-2 bg-white border rounded-3 p-2"
                                    style={drag_over_item_id === item.id ? { backgroundColor: "#F8FBFF", borderColor: "#93C5FD" } : undefined}
                                    draggable
                                    onDragStart={() => this.handleChecklistDragStart(item.id)}
                                    onDragOver={(e) => this.handleChecklistDragOver(e, item.id)}
                                    onDrop={() => this.handleChecklistDrop(item.id)}
                                    onDragEnd={this.handleChecklistDragEnd}
                                >
                                    <span className="icon text-muted px-2" style={{ cursor: "grab", opacity: 0.6 }}>
                                        {"\uf142\uf142"}
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control flex-grow-1"
                                        placeholder={t("checklist_item_description_placeholder")}
                                        value={item.description}
                                        onChange={(e) => this.updateChecklistItem(idx, "description", e.target.value)}
                                    />

                                    <select
                                        className="form-select text-dark wpx-180"
                                        value={item.input_type}
                                        onChange={(e) => {
                                            this.updateChecklistItem(idx, "input_type", e.target.value);
                                            if (e.target.value !== "measurement") {
                                                this.updateChecklistItem(idx, "unit", "");
                                                this.updateChecklistItem(idx, "min", "");
                                                this.updateChecklistItem(idx, "max", "");
                                            }
                                        }}
                                    >
                                        <option value="measurement">{t("measurement_type")}</option>
                                        <option value="check">{t("check_pass_fail_type")}</option>
                                        <option value="yesno">{t("yesno_type")}</option>
                                        <option value="text">{t("text_type")}</option>
                                    </select>

                                    {item.input_type === "measurement" && (
                                        <>
                                            <input
                                                type="text"
                                                className="form-control text-center wpx-80"
                                                placeholder={t("unit")}
                                                value={item.unit}
                                                onChange={(e) => this.updateChecklistItem(idx, "unit", e.target.value)}
                                            />
                                            <span className="text-muted text-14 ms-2 fw-medium">{t("min_label")}</span>
                                            <input
                                                type="text"
                                                className="form-control text-center wpx-80"
                                                placeholder="0"
                                                value={item.min}
                                                onChange={(e) => this.updateChecklistItem(idx, "min", e.target.value)}
                                                style={{ borderLeft: "3px solid #10b981" }}
                                            />
                                            <span className="text-muted text-14 ms-2 fw-medium">{t("max_label")}</span>
                                            <input
                                                type="text"
                                                className="form-control text-center wpx-80"
                                                placeholder="100"
                                                value={item.max}
                                                onChange={(e) => this.updateChecklistItem(idx, "max", e.target.value)}
                                                style={{ borderLeft: "3px solid #ef4444" }}
                                            />
                                        </>
                                    )}
                                    <button
                                        className="btn btn-white border-0 text-danger px-3 fs-5 ms-1 hover-danger"
                                        onClick={() => this.removeChecklistItem(idx)}
                                    >
                                        <span className="text-danger">✕</span>
                                    </button>
                                </div>
                            ))}
                        </div>

                        <div className="alert d-flex align-items-start gap-3 p-3 rounded-3 mb-0" style={{ backgroundColor: "#eff6ff", border: "1px solid #bfdbfe" }}>
                            <span style={{ fontSize: "1.2rem", lineHeight: 1 }}>💡</span>
                            <div style={{ color: "#1e3a8a", fontSize: "14px" }}>
                                <strong>{t("note")}:</strong> {t("checklist_measurement_note_prefix")} <strong>{t("measurement_type")}</strong> {t("checklist_measurement_note_middle")} <strong>Min/Max</strong> {t("checklist_measurement_note_suffix")}
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="bg-white border-top px-4 py-3 d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-medium" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                        {t("cancel")}
                    </button>
                    <button
                        onClick={this.handleSave}
                        className="btn btn-primary px-4 py-2 rounded-3 d-flex align-items-center fw-bold shadow-sm"
                        style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                    >
                        <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
